import styled from "styled-components";

import { ButtonLink } from "@anwb/poncho/components/typography";

export const ProgressIndicator = styled(ButtonLink)`
  border: none;
  white-space: nowrap;
`;
